import React from 'react';
import {
  Edit,
  TabbedForm,
  FormTab,
  FormDataConsumer,
  CardActions,
  ListButton,
  ShowButton,
  SelectInput,
} from 'react-admin';
import BankLinkConfig from './BankLinkConfig';
import SaveOnlyToolbar from '../SaveOnlyToolbar';
import BankTransferConfig from './BankTransferConfig';
import { ConfigTypeEnum } from '../../helpers/mappings';

const redirect = (basePath, id) => `${basePath}/${id}/show`;

const Actions = ({ basePath, data }) => (
  <CardActions>
    <ShowButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

export default props => (
  <Edit
    {...props}
    title=""
    actions={<Actions />}
    undoable={false}
  >
    <TabbedForm redirect={redirect} toolbar={<SaveOnlyToolbar />}>
      <FormTab label="Configuration">
        <SelectInput
          label="Configuration Type"
          source="configType"
          choices={ConfigTypeEnum}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => formData.configType === 'bank_link' && <BankLinkConfig {...rest} />}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData, ...rest }) => formData.configType === 'bank_transfer' && <BankTransferConfig {...rest} />}
        </FormDataConsumer>
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/Config/Edit.jsx